export function scrollToTop(id) {
  window.lenis.stop()
  id = id ? id : 'kl-scroll-top'
  setTimeout(() => {
    document.getElementById(id).scrollIntoView({
      block: 'center',
      behavior: 'smooth',
    })
    window.lenis.start()
  }, 0)
}
